import { dt } from '@primeuix/themes';

export const inputNumberTheme = {
  colorScheme: {
    light: {
      button: {
        color: '{primary.contrast.color}',
        background: '{sd.backgrounds.secondary.color}',
        hover: {
          color: '{primary.contrast.color}',
          background: '{sd.secondary.hovercolor.darker}'
        }
      }
    }
  },
  extend: {
    button: {
      border: {
        radius: '0'
      }
    },
    css: ({ dt: any }: any) => `
    .p-inputnumber-stacked .p-inputnumber-increment-button {
      border-start-end-radius: ${dt('sd.border.radius.medium')}; !important
    }
    .p-inputnumber-stacked .p-inputnumber-decrement-button {
      border-end-end-radius: ${dt('sd.border.radius.medium')}; !important
    }

    .p-inputnumber-stacked .p-inputnumber-button-group {
      height: 100% !important;
      insert-inline-end: 0 !important;
      right: 0 !important;
      top: 0 !important;
    }
  `
  }
};
